<div fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="0px">
  <div>
    <mat-label class="textBoxLabel" [ngStyle]="captionStyles()">
      {{ question.Caption | qnaTranslate }}
      @if (question.IsRequired) {
      <mat-label class="color-city-red"> *</mat-label>
      }
    </mat-label>
  </div>
  <mat-form-field appearance="outline" class="textWrapper">
    @if (!question.IsMultiLine) {
    <div>
      <input
        matInput
        [formControl]="textFormControl"
        (change)="saveComment(textFormControl.value)"
        [required]="question.IsRequired"
      />
    </div>
    } @else {
    <textarea
      matInput
      [formControl]="textFormControl"
      (change)="saveComment(textFormControl.value)"
      [required]="question.IsRequired"
    >
    </textarea>
    }
  </mat-form-field>
  @if (question.IsRequired && !question.Answer && textFormControl.touched) {
  <mat-error>
    {{ isRequiredMessageDisplay }}
  </mat-error>
  }
</div>
